import { selectConfigurationValueFrom } from '@epicuro-next/platform/configuration';
import {
  NAMESPACE_NEWS_FEED,
  NewsfeedConfigurationKeys,
  NewsfeedConfigurations,
  NEWSFEED_CONFIGURATIONS_DEFAULT_VALUES,
} from '@epicuro-next/state/news-feed-state';

export const selectShowSpotlightScrollButtons = selectConfigurationValueFrom<
  NewsfeedConfigurationKeys.ShowSpotlightScrollButtons,
  NewsfeedConfigurations
>(
  NAMESPACE_NEWS_FEED,
  NewsfeedConfigurationKeys.ShowSpotlightScrollButtons,
  false,
);

export const selectIncludePresetsInFilteringRule = selectConfigurationValueFrom<
  NewsfeedConfigurationKeys.includePresetsInFiltering,
  NewsfeedConfigurations
>(
  NAMESPACE_NEWS_FEED,
  NewsfeedConfigurationKeys.includePresetsInFiltering,
  NEWSFEED_CONFIGURATIONS_DEFAULT_VALUES[
    NewsfeedConfigurationKeys.includePresetsInFiltering
  ],
);
